import React, { FC } from 'react';
import { Typography } from 'antd';
const { Title, Paragraph } = Typography;
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import Error from '../../assets/images/error.svg?react';
import { MtsButton } from '@mts-ds/components-react';
import { ButtonColors } from '@mts-ds/components/dist/types/components/button/enums';



const useStyles = makeStyles(({ spacing }) => ({
  error: {
    position: 'relative'
  },
  info: {
    position: 'absolute',
    top: -50,
    left: 250,
    padding: 20,
    '& > *:not(:last-child)': {
      marginBottom: spacing(2)
    }
  },
  image: {
    width: '100%'
  },
  button: {
    paddingRight: 10
  }
}));

interface IProps {
  code?: number;
  text?: string;
  description?: string;
  action?: string;
  actionOnClick?: () => void;
  actionSecondary?: string;
  actionSecondaryOnClick?: () => void;
}

const ErrorPage: FC<IProps> = ({
  code,
  text,
  description,
  action,
  actionOnClick,
  actionSecondary,
  actionSecondaryOnClick
}) => {
  const classes = useStyles();

  return (
    <Grid item xs container justifyContent="center" alignItems="center">
      <Grid className={classes.error}>
        {/*<Error className={classes.image} />*/}
        <Grid className={classes.info}>
          {code && (
            <Title
              style={{ fontSize: '60px', fontWeight: 700, color: 'rgba(0, 0, 0, 1)' }}
              level={1}
            >
              {code}
            </Title>
          )}
          {text && (
            <Title
              style={{ marginTop: 0, fontWeight: 700, color: 'rgba(29, 32, 35, 1)' }}
              level={4}
            >
              {text}
            </Title>
          )}
          {description && (
            <Paragraph
              style={{ color: 'rgba(98, 108, 119, 1)', fontWeight: 400, fontSize: '16px' }}
              color=""
            >
              {description}
            </Paragraph>
          )}
          {actionSecondary && (
            <MtsButton
              className={classes.button}
              color={'secondary' as ButtonColors}
              onClick={actionSecondaryOnClick}
            >
              {actionSecondary}
            </MtsButton>
          )}
          {action && <MtsButton onClick={actionOnClick}>{action}</MtsButton>}
        </Grid>
        <Error className={classes.image} />
      </Grid>
    </Grid>
  );
};

export default ErrorPage;
